// Module
var code = "<!-- ko if: IsAuthenticated --> <a href=\"javascript:;\" class=\"menu-toggler responsive-toggler\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"></a> <!-- /ko -->";
// Exports
export default code;